import InputFormik from "@/common/components/form/InputFormik";
import { IRenter } from "@/types/renter.type";
import { emptySubscription, ISubscription, SUBSCRIPTION_STATUS } from "@/types/subscription.type";
import { FormikProvider, useFormik } from "formik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { maskLicensePlate } from "@/common/helpers/mask.helpers";
import TextAreaFormik from "@/common/components/form/TextAreaFormik";
import InputMoney from "@/common/components/form/CurrencyInputFormik";
import { useState } from "react";
import { AvailablePeriods } from "../../../forms/fields/AvailablePeriods";
import { getPlanByLabel, PLAN_TYPE } from "@/types/plan.type";

type PropsCreatedSubscription = {
  renter: IRenter;
  onSubmit: (subscription: ISubscription) => Promise<{ ok: boolean, errors?: unknown[] }>;
}

export function FormCreatedSubscription({ renter, onSubmit }: PropsCreatedSubscription) {

  const [referencePlan, setReferencePlan] = useState(false);
  const [plan, setPlan] = useState<ReturnType<typeof getPlanByLabel> | null>(null);

  const formik = useFormik({
    initialValues: emptySubscription,
    onSubmit: async (values: ISubscription) => {
      if (!renter?._id) {
        return { ok: false, errors: [{ message: 'ID do locatário não encontrado' }] };
      }
      values.renterId = renter._id;
      values.status = SUBSCRIPTION_STATUS.ACTIVE;
      values.subscriptionType = plan?.value ? plan.value : PLAN_TYPE.WEEKLY;
      if (referencePlan === true) {
        values.planId = "subscription"
        values.splitEnabled = true;
      }

      const result = await onSubmit(values)
      return result 
    }
  });

  const handlePeriodChange = (selectedPeriod: string) => {
    setPlan(getPlanByLabel(selectedPeriod))
  };

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <FormikProvider value={formik}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <div>
            <InputMoney
              name="weeklyValue"
              label="Valor da assinatura"
              placeholder="0.00"
              required
            />
          </div>

          <div>
            <InputFormik
              name="licensePlate"
              label="Placa do veículo"
              mask={maskLicensePlate}
              placeholder="Digite a placa do veículo"
              required
            />
          </div>

          <div>
            <InputFormik
              name="nextDueDate"
              label="Primeiro Vencimento"
              type="date"
              required
            />
          </div>
          <div>
            <InputFormik
              name="endDate"
              label="Data de Término"
              type="date"
              required
            />
          </div>

        </div>
        <div>
          <TextAreaFormik
            name="planName"
            label="Descrição"
            placeholder="Digite a descrição da assinatura"
            required
          />
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:space-x-6">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              name="referencePlan"
              id="showOverdue"
              className="h-4 w-4 text-blue-600 focus:ring-blue-500"
              onClick={() => setReferencePlan(true)}
            />
            <label htmlFor="showOverdue" className="text-sm font-medium text-gray-700">
              Assinatura para plano locação ?
            </label>
          </div>

          {referencePlan && (
            <div className="mt-3 md:mt-0 md:flex-1">
              <AvailablePeriods onChange={handlePeriodChange} />
            </div>
          )}
        </div>


        <div className="md:col-span-2 flex justify-end gap-3 pt-4">

          <ButtonWithLoader
            type="submit"
            isLoading={formik.isSubmitting}
          // disabled={!formik.isValid || formik.isSubmitting}
          >
            Criar Assinatura
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}